/* ============================================================
   O+A Gallery Wall Wishlist
   assets/oa-wishlist.js

   Manages saved items in localStorage under 'oa-gw-saves'.
   Each item: { handle, size, frame, mat }
   size/frame/mat only set when saved from PDP; PLP saves handle only.
   ============================================================ */

window.OAWishlist = (function () {
  const KEY = 'oa-gw-saves';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function save(item) {
    const saves = getAll();
    const existing = saves.findIndex(s => s.handle === item.handle);
    if (existing > -1) {
      saves[existing] = item; // update with latest config
    } else {
      saves.push(item);
    }
    localStorage.setItem(KEY, JSON.stringify(saves));
    dispatch('oa:wishlist:change', saves);
  }

  function remove(handle) {
    const saves = getAll().filter(s => s.handle !== handle);
    localStorage.setItem(KEY, JSON.stringify(saves));
    dispatch('oa:wishlist:change', saves);
  }

  function toggle(item) {
    if (isSaved(item.handle)) {
      remove(item.handle);
      return false;
    } else {
      save(item);
      return true;
    }
  }

  function isSaved(handle) {
    return getAll().some(s => s.handle === handle);
  }

  function getHandles() {
    return getAll().map(s => s.handle);
  }

  function count() {
    return getAll().length;
  }

  function clear() {
    localStorage.removeItem(KEY);
    dispatch('oa:wishlist:change', []);
  }

  // Load from URL param (email link) and merge into localStorage
  function loadFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const savesParam = params.get('saves');
    if (!savesParam) return false;
    const handles = savesParam.split(',').map(h => h.trim()).filter(Boolean);
    if (!handles.length) return false;
    const existing = getAll();
    handles.forEach(handle => {
      if (!existing.some(s => s.handle === handle)) {
        existing.push({ handle });
      }
    });
    localStorage.setItem(KEY, JSON.stringify(existing));
    return true;
  }

  // Build shareable URL
  function buildShareUrl() {
    const handles = getHandles();
    if (!handles.length) return window.location.origin + '/pages/my-gallery';
    return window.location.origin + '/pages/my-gallery?saves=' + handles.join(',');
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  return { getAll, save, remove, toggle, isSaved, getHandles, count, clear, loadFromUrl, buildShareUrl };
})();


/* ============================================================
   PLP CARD PIN BUTTONS
   Injected into .custom-product-card__images on DOMContentLoaded
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const FILLED_PIN = `<svg xmlns="http://www.w3.org/2000/svg" width="15.333" height="27.375" viewBox="0 0 15.333 27.375" aria-hidden="true"><path d="M7.824,27.2a.217.217,0,0,1-.189.17.228.228,0,0,1-.2-.159l-.6-3.664L6.876,16.1,0,16.092a5.187,5.187,0,0,1,.512-2.326,4.639,4.639,0,0,1,1.381-1.7,3.9,3.9,0,0,1,1.911-.772l.007-8.2-.418-.13A7.218,7.218,0,0,1,1.82,1.977a.8.8,0,0,1-.309-.6L1.5.773a.771.771,0,0,1,.68-.762L13.054,0a.755.755,0,0,1,.72.7l.008.685a.692.692,0,0,1-.269.544,8.065,8.065,0,0,1-1.541.985,1.715,1.715,0,0,1-.485.153l.008,8.215a4.014,4.014,0,0,1,2.443,1.237,5.116,5.116,0,0,1,1.4,3.582l-6.915-.015-.032,7.446Z" fill="currentColor"/></svg>`;

  function initCardPins() {
    document.querySelectorAll('.custom-product-card').forEach(card => {
      if (card.querySelector('.oa-pin-btn')) return;

      const handle = card.getAttribute('href')?.split('/products/')?.[1]?.split('?')?.[0];
      if (!handle) return;

      const btn = document.createElement('button');
      btn.className = 'oa-pin-btn';
      btn.setAttribute('aria-label', 'Save to Gallery Wall');
      btn.setAttribute('data-handle', handle);
      btn.innerHTML = FILLED_PIN;

      const saved = window.OAWishlist.isSaved(handle);
      btn.classList.toggle('is-saved', saved);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const nowSaved = window.OAWishlist.toggle({ handle });
        btn.classList.toggle('is-saved', nowSaved);
        btn.setAttribute('aria-label', nowSaved ? 'Saved to Gallery Wall' : 'Save to Gallery Wall');
      });

      const imagesWrap = card.querySelector('.custom-product-card__images');
      if (imagesWrap) {
        imagesWrap.style.position = 'relative';
        imagesWrap.appendChild(btn);
      }
    });
  }

  initCardPins();

  // Re-run after load-more appends new cards
  document.addEventListener('oa:cards:appended', initCardPins);

  // Also observe for dynamically added cards
  const grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver(initCardPins).observe(grid, { childList: true, subtree: true });
  }
});